import { Component, ViewEncapsulation } from '@angular/core';

/**
 * A sidebar navigation row.
 *
 * Declared with an attribute selector so it decorates an element the consumer
 * already owns — `routerLink`, `routerLinkActive`, `*appHasPermission` and
 * `matMenuTriggerFor` all stay exactly where Angular expects them:
 *
 *   <a ui-nav-item routerLink="/orders" routerLinkActive="active">
 *     <ui-icon name="ShoppingBag"></ui-icon>
 *     <span class="title">Orders</span>
 *   </a>
 *
 * The `active` class (however it is applied) drives the selected state, and
 * `.ui-nav-item__trailing` right-aligns a counter badge or meta text.
 */
@Component({
  selector: 'a[ui-nav-item], span[ui-nav-item], div[ui-nav-item], button[ui-nav-item]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['./nav-item.component.scss'],
  // Content is projected from the consumer's template, so it belongs to the
  // consumer's style scope. Disabling encapsulation lets the row own its own
  // layout without every caller re-declaring it.
  encapsulation: ViewEncapsulation.None,
})
export class NavItemComponent {}
